import React from "react";
import classes from "./TabPanel.module.css";

const TabPanel = ({ component: Component, componentParams = null }) => {
  if (!Component) return null;
  return (
    <div className={classes["panel"]}>
      <Component {...(componentParams || {})} />
    </div>
  );
};

export default TabPanel;
